import styled from "styled-components";
import theme from "~/styles/theme";

export const Content = styled.div`
    max-width: 950px;
    margin: 0 auto;

    .title-header {
        display: grid;
        grid-template-columns: 1fr 2fr;
        margin-bottom: 2rem;
    }

    .title-text {
        display: flex;
        flex-direction: column;
        justify-content: center;

        h1 {
            color: ${theme.color.primary.background};
        }

        p {
            margin: 1rem 0;
            font-size: 1rem;
            line-height: 1.5rem;
        }

        strong {
            font-size: 1rem;
            line-height: 1.5rem;
        }
    }

    .business-link {
        margin: 2rem 0;
        padding: 1rem;
        font-size: 1.25rem;
        line-height: 1.5rem;

        strong,
        p,
        a {
            font-size: 1.25rem;
            line-height: 1.5rem;
        }

        strong {
            color: ${theme.color.primary.background};
            margin-right: 0.75rem;
        }

        p {
            color: ${theme.color.baseLighter};
        }

        a {
            color: ${theme.color.baseLighter};
            font-weight: bold;
        }
    }

    @media (max-width: 800px) {
        .title-header {
            grid-template-columns: 1fr;
        }
    }
`;

export const CategoryContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
`;

export const CategoryHeader = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0;

    h1 {
        color: ${theme.color.secondary.accent};
    }

    a {
        text-decoration: none;
        color: ${theme.color.baseLighter};

        &:hover {
            color: ${theme.color.primary.background};
        }
    }

    p {
        color: ${theme.color.baseLighter};
    }

    @media (max-width: 900px) {
        text-align: center;

        flex-direction: column;

        p {
            margin: 1rem 0;
        }
    }
`;

export const ButtonContainer = styled.div`
    margin: 3.5rem 0;
    margin-bottom: 1.5rem;

    @media (max-width: 480px) {
        position: relative;
        bottom: 1.5rem;
    }
`;

export const CategoryCardContainer = styled.div<{ active: boolean; src: string }>`
    max-width: 21.875rem;
    width: 100%;
    min-height: 14.5rem;
    margin: 0.5rem 0;
    overflow: hidden;

    cursor: pointer;
    position: relative;

    background-image: ${({ src }) => `url(${src})`};
    background-size: cover;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    border-radius: 0.9rem;

    .choose-button {
        width: 100%;
        min-height: 3.5rem;
        position: absolute;
        bottom: 0;
        border-bottom-left-radius: 0.9rem;
        border-bottom-right-radius: 0.9rem;
        z-index: 10;

        display: flex;
        align-items: center;
        justify-content: center;

        transition: ease-in-out 0.3s;

        color: #ffffff;
        background: rgba(0, 0, 0, 0.35);

        cursor: pointer;

        span {
            font-size: 1rem;
            font-weight: 600;
            margin-right: 0.5rem;
        }
    }

    p {
        font-size: 1rem;
        margin-top: 0.5rem;
        color: ${({ active }) => (active ? "#ffffff" : "")};
    }

    .carousel-container {
        width: 100%;
        height: 100%;
        min-height: 14.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.9rem;
    }

    .carousel-image {
        height: 100%;
        min-height: 14.5rem;
        object-fit: cover;
    }

    img {
        border-radius: 0.9rem;
    }

    &:hover {
        button {
            background: ${theme.color.primary.background};
            opacity: 0.9;
        }

        p {
            color: #ffffff;
        }
    }
`;

export const DivImage = styled.div<{ src: string }>`
    max-width: 21.875rem;
    width: 100%;
    min-height: 14.5rem;
    background-image: ${({ src }) => `url(${src})`};
    background-size: cover;
`;

export const Box = styled.div`
    max-width: 15.9rem;
    min-height: 3.5rem;
    width: 100%;
    margin: 0.5rem auto;

    display: flex;
    align-items: center;
    justify-content: center;

    button {
        background: none;
        font-size: 1rem;
        font-weight: 600;
    }
`;

export const TimelineContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
`;

export const TimelineItem = styled.div<{ active: boolean }>`
    display: flex;
    align-items: center;
    justify-content: center;

    .dot {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        border: 2px solid ${({ active }) => (active ? "" : theme.color.baseLighter)};
        background-color: ${({ active }) => (active ? theme.color.primary.background : "")};
        color: ${({ active }) => (active ? "#fff" : theme.color.baseLighter)};
        font-size: 1.25rem;
        line-height: 1.5rem;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    span {
        font-size: 1.25rem;
        line-height: 2.5rem;
        text-align: center;
        margin-left: 1rem;

        color: ${({ active }) => (active ? theme.color.primary.background : theme.color.baseLighter)};
    }

    @media (min-width: 374px) and (max-width: 770px) {
        display: ${({ active }) => (active ? "flex" : "none")};
    }
`;
